import React from 'react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { getColor, rgbaColor } from 'helpers/utils';
import * as echarts from 'echarts/core';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { PieChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { useContext } from 'react';
import AppContext from 'context/Context';
import { colorCodes } from 'constants/color';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  PieChart,
  CanvasRenderer,
  LegendComponent
]);

const getOption = (isDark,pieData) => {


  const total = pieData.reduce((acc, curr) => acc + curr.value, 0);

  const formattedData = pieData.map(item => ({
    ...item,
    label: {
      show: true,
      position: 'inside',
      formatter: `{d}%`,
      textStyle: {
        color: isDark ? '#FFFFFF' : '#333333',
        fontWeight: 'bold'
      }
    }
  }));

  return {
    legend: {
      left: 'right',
      bottom: 0,
      itemWidth: 12,
      itemHeight: 12,
      borderRadius: 0,
      icon: 'circle',
      inactiveColor: getColor('gray-400'),
      inactiveBorderColor: 'transparent',
      textStyle: {
        color: getColor('gray-600'),
        fontSize: 12,
        fontFamily: 'Poppins',
        fontWeight: '500'
      },
      itemGap: 16,
      data: pieData.map(item => item.name), // Your legend data
      orient: 'vertical'
    },
    series: [
      {
        type: 'pie',
        radius: '100%',
        label: {
          show: false
        },
        center: ['50%', '50%'],
        itemStyle: {
          borderWidth: 2,
          borderColor: isDark ? '#121E2D' : getColor('gray-100')
        },
        data: formattedData
      }
    ],
    tooltip: {
      trigger: 'item',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('dark') },
      borderWidth: 1,
      transitionDuration: 0,
      axisPointer: {
        type: 'none'
      },
      formatter: params => {
        const { name, value } = params;
        const percentage = ((value / total) * 100).toFixed(2);
        return `${name}: ${value} (${percentage}%)`;
      }
    }
  };
};



const CagegorywiseSummaryPieChart = ({data}) => {
  const { config } = useContext(AppContext);
  const { isDark } = config;

  const pieData = [
    { value:  data.totalTicketsTemporaryResolved, name: 'Temporary Resolved', itemStyle: { color:colorCodes[1] } },
    { value: data.totalTicketsPermenentlyResolved, name: 'Permanently Resolved', itemStyle: { color: colorCodes[2]  } },
    { value: data.totalTicketsPending, name: 'Pending', itemStyle: { color: colorCodes[5]  } },
  ];

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={getOption(isDark,pieData)}
      className="h-100 w-100"
    />
  );
};

export default CagegorywiseSummaryPieChart;
